module.exports = __webpack_public_path__ + "static/media/bh.90ad3cbd.svg";